import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const sessionId = sp.get("session_id");
  const [state, setState] = useState("polling"); // polling | paid | failed
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let cancel = false;
    const poll = async (n = 0) => {
      if (cancel) return;
      if (n >= 8) { setState("failed"); return; }
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired") { setState("failed"); return; }
        setTimeout(() => { setTries(n + 1); poll(n + 1); }, 2000);
      } catch {
        setTimeout(() => { setTries(n + 1); poll(n + 1); }, 2000);
      }
    };
    poll();
    return () => { cancel = true; };
  }, [sessionId]);

  return (
    <div className="p-10 min-h-[60vh] flex items-center justify-center" data-testid="billing-success-page">
      <div className="panel p-10 max-w-md text-center">
        {state === "polling" && (
          <>
            <Loader2 className="w-10 h-10 text-[#FFB000] mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-bold text-2xl mb-2">Confirming payment…</h1>
            <p className="text-sm text-zinc-500">Attempt {tries + 1} of 8</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-10 h-10 text-[#00E676] mx-auto mb-4" />
            <h1 className="font-heading font-black text-3xl uppercase mb-2">Subscribed.</h1>
            <p className="text-sm text-zinc-500 mb-6">Your DARA Scale plan is active. Welcome to the command deck.</p>
            <button onClick={() => nav("/app")} className="bg-[#FFB000] text-black font-bold font-mono text-[11px] uppercase tracking-wider px-6 py-3 hover:bg-[#E59E00]">
              Go to dashboard
            </button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="w-10 h-10 text-[#FF3B30] mx-auto mb-4" />
            <h1 className="font-heading font-bold text-2xl mb-2">Payment not confirmed.</h1>
            <p className="text-sm text-zinc-500 mb-6">If you completed the charge, it may take a few minutes to reflect.</p>
            <button onClick={() => nav("/app/settings?tab=billing")} className="border border-zinc-700 px-6 py-3 font-mono text-[11px] uppercase tracking-wider hover:bg-zinc-900">
              Back to billing
            </button>
          </>
        )}
      </div>
    </div>
  );
}
